var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47021 16C4.05421 16 0.470215 12.424 0.470215 8C0.470215 3.584 4.05421 0 8.47021 0C12.8942 0 16.4702 3.584 16.4702 8C16.4702 12.424 12.8942 16 8.47021 16ZM11.0225 10.9681C11.1185 11.0241 11.2225 11.0561 11.3345 11.0561C11.5345 11.0561 11.7345 10.9521 11.8465 10.7601C12.0145 10.4801 11.9265 10.1121 11.6385 9.93614L8.79053 8.24014V4.54414C8.79053 4.20814 8.51853 3.94414 8.19053 3.94414C7.86253 3.94414 7.59053 4.20814 7.59053 4.54414V8.58414C7.59053 8.79214 7.70253 8.98414 7.88653 9.09614L11.0225 10.9681Z",
    fill: "#61AEA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6f6260e87ab73a2eff018e31e76cda7f.svg";
export { ForwardRef as ReactComponent };